import type MailboxCalendarConfiguration from 'owa-service/lib/contract/MailboxCalendarConfiguration';
import getMailboxCalendarConfigurationOperation from 'owa-service/lib/operation/getMailboxCalendarConfigurationOperation';
import type GetMailboxCalendarConfigurationResponse from 'owa-service/lib/contract/GetMailboxCalendarConfigurationResponse';
import type { MailboxInfo } from 'owa-client-types';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import getMailboxRequestOptions from 'owa-service/lib/getMailboxRequestOptions';
import { isCapabilityEnabled } from 'owa-capabilities';
import { serviceRequestCapability } from 'owa-capabilities-definitions/lib/serviceRequestCapability';

export default async function getMailboxCalendarConfiguration(
    mailboxInfo: MailboxInfo = getGlobalSettingsAccountMailboxInfo()
): Promise<MailboxCalendarConfiguration | null> {
    if (!isCapabilityEnabled(serviceRequestCapability, mailboxInfo)) {
        return null;
    }

    const response: GetMailboxCalendarConfigurationResponse =
        await getMailboxCalendarConfigurationOperation(getMailboxRequestOptions(mailboxInfo));
    if (response.ErrorCode) {
        return null;
    } else {
        return response.Options;
    }
}
